<p-menu #menu_content
  [styleClass]="menuClass.toString()"
  [model]="loadedItems ?? items"
  [popup]="true"
  appendTo="body"
  (onHide)="hide()">
</p-menu>
<button medsurf-design-input-button [id]="name"
  [id]="name"
  [title]="tooltipLabel ?? ''"
  class="h-full"
  [inputClass]="buttonInputClass"
  [iconClass]="buttonIconClass || ''"
  [iconClassAfter]="isOpen() ? iconOpen : iconClose"
  (click)="toggle($event)"
  [label]="label ? (label | translate) : ''">
</button>
